
import { Gig, Venue } from '@/types/gigs';

export const mockGigs: Gig[] = [
  {
    id: '1',
    name: 'The Roxy Show',
    date: '2023-11-18',
    time: '21:00',
    venue: 'The Roxy',
    location: 'Los Angeles, CA',
    status: 'confirmed',
    payment: 850,
    capacity: 500,
    duration: '45 min',
    ticketsSold: 423,
    source: 'local'
  },
  {
    id: '2',
    name: 'Miami Music Festival',
    date: '2023-12-02',
    time: '16:30',
    venue: 'Bayfront Park',
    location: 'Miami, FL',
    status: 'confirmed',
    payment: 1200,
    capacity: 2000,
    duration: '60 min',
    ticketsSold: 1850,
    source: 'eventbrite'
  },
  {
    id: '3',
    name: 'Brooklyn Bar Night',
    date: '2023-12-10',
    time: '22:00',
    venue: 'Williamsburg Bar',
    location: 'Brooklyn, NY',
    status: 'pending',
    payment: 500,
    capacity: 150,
    duration: '30 min',
    ticketsSold: 42,
    source: 'local'
  },
  {
    id: '4',
    name: 'Austin Music Showcase',
    date: '2023-12-15',
    time: '20:00',
    venue: 'Continental Club',
    location: 'Austin, TX',
    status: 'confirmed',
    payment: 750,
    capacity: 300,
    duration: '45 min',
    ticketsSold: 187,
    source: 'songkick'
  },
  {
    id: '5',
    name: 'Seattle Indie Fest',
    date: '2023-12-22',
    time: '19:00',
    venue: 'Neumos',
    location: 'Seattle, WA',
    status: 'confirmed',
    payment: 950,
    capacity: 650,
    duration: '50 min',
    ticketsSold: 413,
    source: 'eventbrite'
  },
  {
    id: '6',
    name: 'New Year Eve Special',
    date: '2023-12-31',
    time: '23:00',
    venue: 'The Troubadour',
    location: 'West Hollywood, CA',
    status: 'confirmed',
    payment: 1500,
    capacity: 400,
    duration: '90 min',
    ticketsSold: 321,
    source: 'local'
  },
  {
    id: '7',
    name: 'Nashville Songwriter Night',
    date: '2024-01-05',
    time: '19:30',
    venue: 'Bluebird Cafe',
    location: 'Nashville, TN',
    status: 'pending',
    payment: 450,
    capacity: 90,
    duration: '40 min'
  },
  {
    id: '8',
    name: 'Chicago Blues Bar',
    date: '2024-01-12',
    time: '21:30',
    venue: 'Kingston Mines',
    location: 'Chicago, IL',
    status: 'inquiry',
    payment: 600,
    capacity: 200,
    duration: '60 min'
  }
];

// Mock venues data
export const mockVenues: Venue[] = [
  {
    id: '1',
    name: 'The Roxy',
    city: 'Los Angeles',
    state: 'CA',
    type: 'Club',
    capacity: 500,
    rating: 4.5,
    played: true,
    image: 'https://source.unsplash.com/random/800x600/?concert-venue',
    website: 'https://www.theroxy.com',
    contactEmail: 'bookings@theroxy.com'
  },
  {
    id: '2',
    name: 'Bayfront Park Amphitheater',
    city: 'Miami',
    state: 'FL',
    type: 'Festival',
    capacity: 2500,
    rating: 4.2,
    played: true,
    image: 'https://source.unsplash.com/random/800x600/?amphitheater'
  },
  {
    id: '3',
    name: 'Williamsburg Music Hall',
    city: 'Brooklyn',
    state: 'NY',
    type: 'Concert Hall',
    capacity: 650,
    rating: 4.0,
    played: false,
    image: 'https://source.unsplash.com/random/800x600/?music-hall'
  },
  {
    id: '4',
    name: 'Continental Club',
    city: 'Austin',
    state: 'TX',
    type: 'Bar',
    capacity: 300,
    rating: 4.7,
    played: true,
    image: 'https://source.unsplash.com/random/800x600/?bar-venue'
  },
  {
    id: '5',
    name: 'Neumos',
    city: 'Seattle',
    state: 'WA',
    type: 'Club',
    capacity: 650,
    rating: 4.3,
    played: false,
    image: 'https://source.unsplash.com/random/800x600/?club-venue'
  },
  {
    id: '6',
    name: 'The Troubadour',
    city: 'West Hollywood',
    state: 'CA',
    type: 'Club',
    capacity: 400,
    rating: 4.8,
    played: true,
    image: 'https://source.unsplash.com/random/800x600/?troubadour'
  },
  {
    id: '7',
    name: 'Bluebird Cafe',
    city: 'Nashville',
    state: 'TN',
    type: 'Bar',
    capacity: 90,
    rating: 4.9,
    played: false,
    image: 'https://source.unsplash.com/random/800x600/?songwriter-venue'
  },
  {
    id: '8',
    name: 'Kingston Mines',
    city: 'Chicago',
    state: 'IL',
    type: 'Bar',
    capacity: 200,
    rating: 4.4,
    played: false,
    image: 'https://source.unsplash.com/random/800x600/?blues-bar'
  },
  {
    id: '9',
    name: 'Red Rocks Amphitheatre',
    city: 'Morrison',
    state: 'CO',
    type: 'Concert Hall',
    capacity: 9500,
    rating: 5.0,
    played: false,
    image: 'https://source.unsplash.com/random/800x600/?red-rocks'
  }
];
